import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { BillPaymentPrepayDialogComponent } from 'src/app/components/bill-payment-prepay-dialog/bill-payment-prepay-dialog.component';
import { tBillPayModel, BillPay_Patient_PackageModel } from 'src/app/models/tBillPayModel';
import { BillPaymentPackageTotalAmountInputValueDialogComponent } from 'src/app/components/bill-payment-package-total-amount-input-value-dialog/bill-payment-package-total-amount-input-value-dialog.component';

var TAG = "BillPayPayment_PackageToalAmount_InputValueDialogService";

@Injectable({
    providedIn: 'root'
})
export class BillPayPayment_PackageToalAmount_InputValueDialogService {

    constructor(private log: LoggerService,
        private modalService: NgbModal,
    ) { }



    openDialog(element: tBillPayModel,selectedModel: BillPay_Patient_PackageModel,orgArAmount:number, isChangePay?:boolean) {
        this.log.i(TAG, 'open Dialog');
        const modalRef = this.modalService.open(BillPaymentPackageTotalAmountInputValueDialogComponent, { size: 'lg', centered: true, backdrop: 'static' });

        // modalRef.componentInstance.dataList = dataList;
        // modalRef.componentInstance.dataList_Payment = dataList_Payment;
        modalRef.componentInstance.selectedBillPayModel = element;
        modalRef.componentInstance.selectedBillPay_Patient_PackageModel = selectedModel;
        modalRef.componentInstance.orgArAmount = orgArAmount;
        modalRef.componentInstance.isChangePay = isChangePay;

        console.log('isChangePay = '+isChangePay);

        return modalRef;

    }



}
